import { render, staticRenderFns } from "./ContactLensImageTypeSwitcher.vue?vue&type=template&id=63bcc526&scoped=true&"
import script from "./ContactLensImageTypeSwitcher.vue?vue&type=script&lang=ts&"
export * from "./ContactLensImageTypeSwitcher.vue?vue&type=script&lang=ts&"
import style0 from "./ContactLensImageTypeSwitcher.vue?vue&type=style&index=0&id=63bcc526&scoped=true&lang=stylus&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63bcc526",
  null
  
)

export default component.exports